import { type RovoInstrumentedError } from '@atlassian/conversation-assistant-utils/httpUtils';

import { generateTraceId } from './generateTraceId';

export class DeepResearchError extends Error implements RovoInstrumentedError {
	errorAttributes: RovoInstrumentedError['errorAttributes'];
	message_template: string;

	constructor(
		message: string,
		params: {
			traceId?: string;
			requestId?: string;
		} = {},
	) {
		super(message);
		this.name = this.constructor.name;
		this.message_template = 'DEEP_RESEARCH_ERROR';

		this.errorAttributes = {
			errorCode: 'DEEP_RESEARCH_ERROR',
			traceId: params.traceId ?? `DeepResearch-${generateTraceId()}`,
			requestId: params.requestId,
		};
	}
}
